import { Component, Input } from '@builder.io/sdk';

export const formFields = (showIf?: string) =>
  [
    {
      name: 'form',
      type: 'reference',
      model: 'marketo-forms',
      showIf,
      helperText: 'Select a Marketo form to embed here. The form must already exist in the Marketo instance.',
    },
  ] as const satisfies DeepReadonly<Input[]>;

export const formConfig = {
  name: 'Form Detail',
  inputs: formFields(),
} as Component;

export default formConfig;
